var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Tick_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Tick_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 19,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.108 3.654a1.111 1.111 0 0 1 1.655 1.477l-.093.104-11.24 11.11c-.405.4-1.039.426-1.472.081l-.104-.094-5.426-5.55a1.111 1.111 0 0 1 1.485-1.646l.104.093 4.644 4.75L18.108 3.654Z",
    fill: "currentcolor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Tick_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.778-17.778h55.556v55.556h-55.556v-55.556Z",
    fill: "currentcolor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Tick_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgTick;